import Group from './Group'
import Input from './Input'
import Items from './Items'
import Label from './Label'

export default { Input, Group, Items, Label }
